module.exports = __webpack_public_path__ + "media/step_3_ru.54da62e1.mp3";